// LiveStreamCard.js
import { connect } from 'react-redux';

import getUserData from '../selector/getUserData.js';
import getFormattedLiveStreamViewers from '../selector/getFormattedLiveStreamViewers.js';
import getMeData from '../selector/getMeData.js';
import getLiveStreamLanguageBadges from '../selector/getLiveStreamLanguageBadges.js';
import getUserBadges from '../selector/getUserBadges.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getOperationData from '../selector/getOperationData.js';

import fetchUser from '../action/fetchUser.js';
import fetchTranslationByKey from '../action/fetchTranslationByKey.js';
import subscribeOnlineStatus from '../action/subscribeOnlineStatus.js';

import LiveStreamCard from '../component/LiveStreamCard.jsx';
import i18n from '../resource/i18n.js';
import getCurrentLanguage from '../resource/getCurrentLanguage.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import { PUBLIC_BADGE_URL_PATH } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId, streamId }) => {
  const username = getUserData(state, userId, 'username');
  const formattedViewers = getFormattedLiveStreamViewers(state, streamId);
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const [location] = getUserBadges(state, userId, 'locations');
  const locationKey = location?.replace?.(':', '_') || '';
  return {
    meId,
    username,
    formattedViewers,
    isAuthed,
    languageBadges: getLiveStreamLanguageBadges(
      state,
      streamId,
      getCurrentLanguage()
    ),
    locationKey,
    isLocationKeyTranslationFetched: getNetworkingData(
      state,
      ['translation', locationKey, i18n.language],
      'isFetched'
    ),
    isLiveStreaming: getLiveStreamData(state, [userId], 'isLiveStreaming'),
    isPrivateUserSubscribed: getOperationData(
      state,
      ['pusher', 'channels'],
      `private-enc-user@${userId}`
    )?.subscribed,
    isKaraokeDeviceOnline: !!getLiveStreamData(state, [streamId], 'device'),
    publicBadgeUrlPath: getRemoteConfigData(state, PUBLIC_BADGE_URL_PATH),
    status: getLiveStreamData(state, [streamId], 'status'),
    privateShowStatus: getPrivateShowStatus(state, streamId),
  };
};

const mapDispatchToProps = (dispatch, { userId }) => {
  return {
    fetchUser: () => dispatch(fetchUser({ id: userId })),
    subscribeOnlineStatus: () => dispatch(subscribeOnlineStatus({ userId })),
    fetchTranslationByKey: ({ key }) =>
      dispatch(fetchTranslationByKey({ key })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamCard);
